import { useTranslation } from 'react-i18next'

export const SummaryCard = ({ title, count, subTitle, onClick }: any) => {
  const { t } = useTranslation()
  return (
    <div
      className='flex justify-between rounded-[10px] bg-white p-5 shadow sm:px-[18px] sm:py-[30px] cursor-pointer uppercase'
      onClick={onClick}
    >
      <div>
        <p className='text-md'>{t(title) + (count ? ` (${count})` : '')}</p>
        <h3 className='text-2xl'>{subTitle}</h3>
      </div>
    </div>
  )
}
